import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { sendEventLoanConditions } from 'shared/lib/sendGAEvents';

import { getFormattedValues } from '../lib/getFormattedValues';
import type { MfoState } from '../types';

const initialState: MfoState = {
  data: { amount: 50000, period: 60, snils: '' },
};

export const mfoFormSlice = createSlice({
  name: 'mfoForm',
  initialState,
  reducers: {
    setMfoInfo: (state, { payload }: PayloadAction<Partial<MfoState['data']>>) => {
      state.data = { ...state.data, ...payload };
      const { amount, period, snils } = getFormattedValues(state?.data);
      sendEventLoanConditions({ amount, term: period, snils });
    },
  },
});

export const { setMfoInfo } = mfoFormSlice.actions;
